<template>
    <el-popover
        ref="task-create"
        placement="top"
        title=""
        width="700"
        trigger="manual"
        v-model="isVisible"
        :visible-arrow="false"
        popper-class="event-task-create"
        v-on-clickaway="hideForm"
    >
        <el-row class="mb10">
            <el-col :span="2" class="form-label">
                Кому
            </el-col>
            <el-col :span="3">
                <el-radio v-model="assignedType" label="self" class="form-radio">
                    Себе
                </el-radio>
            </el-col>
            <el-col :span="6" class="text-center">
                <el-radio v-model="assignedType" label="employer" class="form-radio">
                    Сотруднику
                </el-radio>
            </el-col>
            <el-col :span="13">
                <el-select
                    v-model="task.assigned_user_id"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    autocomplete
                    filterable
                    clearable
                    size="mini"
                    :disabled="assignedType === 'self' || assignedType === null"
                >
                    <el-option v-for="item in assignedList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <div class="form-error" v-if="errors.assigned_user_id" v-text="errors.assigned_user_id[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="2" class="form-label">
                Срок
            </el-col>
            <el-col :span="6">
                <el-date-picker
                    v-model="task.planned_date"
                    type="date"
                    placeholder="дата"
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    size="mini"
                    class="w100"
                    :picker-options="pickerOptions"
                />
                <div class="form-error" v-if="errors.planned" v-text="errors.planned[0]"></div>
            </el-col>
            <el-col :span="3" class="form-label text-right pr10">
                Время
            </el-col>
            <el-col :span="4">
                <el-select v-model="task.planned_time" placeholder="" size="mini">
                    <el-option
                        v-for="item in defaultTimeList"
                        :key="item"
                        :value="item"
                    />
                </el-select>
            </el-col>
            <el-col :span="4" class="form-label text-right pr10">
                Приоритет
            </el-col>
            <el-col :span="5">
                <el-select v-model="task.priority" placeholder="" size="mini">
                    <el-option
                        v-for="taskPriority in taskPriorityList"
                        :key="taskPriority.id"
                        :label="taskPriority.name"
                        :value="taskPriority.id"
                    />
                </el-select>
                <div class="form-error" v-if="errors.priority" v-text="errors.priority[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col :span="3" class="form-label">
                Заголовок
            </el-col>
            <el-col :span="21">
                <el-input v-model="task.title" autocomplete="on" size="mini" clearable />
                <div class="form-error" v-if="errors.title" v-text="errors.title[0]"></div>
            </el-col>
        </el-row>
        <el-row class="mb10">
            <el-col>
                <el-input
                    type="textarea"
                    :rows="5"
                    placeholder=""
                    v-model="task.new_comment"
                />
            </el-col>
        </el-row>
        <el-row class="mb16">
            <el-col :span="1">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="task.files"
                    :show-file-list="false"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer pt10" />
                </el-upload>
            </el-col>
            <el-col :span="23" class="form-file-list event-attachments ">
                <el-tag
                    v-for="file in task.files"
                    :key="file.name"
                    closable
                    :type="''"
                    @close="handleClose(file)"
                    size="mini"
                    :disable-transitions="true"
                >
                    {{ file.name }}
                </el-tag>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-button type="warning" @click="create">
                    Создать
                </el-button>
                <el-button type="info" @click="hideForm">
                    Отменить
                </el-button>
            </el-col>
        </el-row>
    </el-popover>
</template>

<script>
import '@/assets/styles/events.scss';
import { mixin as clickaway } from 'vue-clickaway';
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';
import { eventBus } from '@/common/eventBus';

const initialState = {
    assigned_user_id: null,
    priority: localReferences.taskPriorities.middle,
    title: null,
    planned: null,
    planned_date: null,
    planned_time: '9:00',
    new_comment: '',
    files: [],
    related_entity_id: null,
    related_entity_type: null
};

export default {
    name: 'EventTaskCreate',
    mixins: [
        clickaway
    ],
    data() {
        return {
            showForm: false,
            pickerOptions,
            assignedType: null,
            task: { ...initialState },
            errors: {}
        };
    },
    props: {
        entityType: {
            type: String,
            default: 'lead'
        },
        entityId: {
            type: Number,
            default: 0
        },
        entity: {
            type: Object,
            default: () => {}
        },
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        assignedList() {
            return this.$store.state.references.employers;
        },
        taskPriorityList() {
            return localReferences.taskPrioritiesList;
        },
        defaultTimeList() {
            const start = 9;
            const end = 19;
            const result = [];
            for (let index = start; index <= end; index++) {
                result.push(index + ':00');
            }
            return result;
        }
    },
    methods: {
        hideForm(event) {
            if (this.isVisible && event.target.className !== 'add-task-icon') {
                eventBus.$emit('hide-task-create-form');
                this.resetForm();
            }
        },
        resetForm() {
            this.task = { ...initialState };
            this.assignedType = null;
            this.errors = {};
        },
        handleChange(file, fileList) {
            this.task.files = fileList;
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleClose(tag) {
            this.files.splice(this.files.indexOf(tag), 1);
        },
        prepareFormData() {
            const formData = new FormData();
            formData.append('status_id', localReferences.taskStatuses.assigned);
            formData.append('title', this.task.title);
            formData.append('new_comment', this.task.new_comment);
            formData.append('assigned_user_id', this.task.assigned_user_id);
            this.task.planned = this.task.planned_date ? this.task.planned_date + ' ' + this.task.planned_time : null;
            formData.append('planned', this.task.planned);
            formData.append('priority', this.task.priority);
            formData.append('related_entity_id', this.entityId);
            formData.append('related_entity_type', this.entityType);
            formData.set('files', JSON.stringify(this.task.files));
            this.task.files.forEach(file => {
                if (file.raw) {
                    formData.append('files' + file.uid, file.raw, file.raw.name);
                }
            });
            return formData;
        },
        async create() {
            try {
                await this.$store.dispatch('tasks/createTask', {
                    id: null,
                    data: this.prepareFormData()
                });
                eventBus.$emit('hide-task-create-form');
                eventBus.$emit('tasks-need-update', { entityType: this.entityType, entityId: this.entityId });
                this.resetForm();
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
            }
        }
    },
    watch: {
        assignedType(value) {
            this.task.assigned_user_id = value === 'self' ? this.$store.state.auth.employerId : null;
        }
    }
};
</script>
